module.exports = new __parcel__URL__("arrow.8784dde6.png").toString();